import { ServiceRepo } from '@core/repositories'

const resource = "/ticket"

export default {
  fetch(payload, config) {
    return ServiceRepo.post(`${resource}s.json`, payload, config)
  },
}
